import {styleRule, StyleSheet} from "../../../stem-core/src/ui/Style";

import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {UI} from "../../../stem-core/src/ui/UIBase";
import {Messages} from "../../Messages";
import {authService} from "../../../client/connection/Services";
import {PanelLink} from "./Primitives";
import {startDashboardFlow} from "../flows/startFlow";
import {AuthService} from "../../../client/connection/services/AuthService";


class LoginFooterStyle extends StyleSheet {
    @styleRule
    loginExistingUserMessage = {
        ...this.themeProps.PANEL_MESSAGE_STYLE,
        fontSize: this.themeProps.MERCHANT_FONT_SIZE_LARGE
    };

    @styleRule
    loginExistingUserLink = {
        ...this.themeProps.AUTH_LINK_STYLE,
        fontSize: "inherit",
        whiteSpace: "nowrap",
    };
}

@registerStyle(LoginFooterStyle)
export class LoginFooter extends UI.Element {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            controller: null,
            label: "",
            linkLabel: Messages.logIn,
            manageAccount: false, // TODO: Convince Mihai this should be true by default.
            manageAccountLabel: Messages.manageMyAccount,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.loginExistingUserMessage);
    }

    render() {
        const {styleSheet} = this;
        const {controller, label, linkLabel, anid, manageAccount, manageAccountLabel} = this.options;

        if (authService.isAuthenticated()) {
            return manageAccount
                ? <PanelLink value={manageAccountLabel} onClick={(e) => controller.onManageAccountClick(e)}
                             anid={anid} className={styleSheet.loginExistingUserLink}/>
                : null;
        }

        return [
            label || controller.getLoginFooterMessage(),
            <PanelLink value={linkLabel} onClick={(e) => controller.onLoginClick(e)} anid={anid}
                       className={styleSheet.loginExistingUserLink} />,
        ];
    }

    onMount() {
        super.onMount();
        this.attachListener(authService, AuthService.EventTypes.AUTHENTICATION_CHANGE, () => this.redraw());
    }
}

export function PanelLoginFooterBuilder(ControllerClass) {
    return (options, children) => <LoginFooter controller={new ControllerClass()} {...options}>{children}</LoginFooter>;
}

@registerStyle(LoginFooterStyle)
export class PromptInlineUserDashboard extends PanelLink {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            label: Messages.manageMyAccount,
        };
    }

    extraNodeAttributes(attr) {
        super.extraNodeAttributes(attr);
        attr.addClass(this.styleSheet.loginExistingUserMessage);
        attr.addClass(this.styleSheet.loginExistingUserLink);
    }

    render() {
        return this.options.label;
    }

    onMount() {
        super.onMount();
        this.addClickListener(() => startDashboardFlow());
    }
}
